import { createContext, useContext, useReducer } from 'react';
import ajaxUser from '../util/remote/ajaxUser';

const initialState = { 
  user: null,
  connectedProfiles: null,
  activeProfile: null,
  myPermissions: null,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const AuthContext = createContext();

export const AuthProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  const getMyProfile = async () => {
    const server_response  = await ajaxUser.fetchMyProfile();
    if(server_response.status === "OK"){
        dispatch({ type: 'user', payload: server_response.details });
    }
  };


  const getProfiles = async(refresh)=>{
    if(refresh){
      dispatch({type: 'connectedProfiles', payload: null});
    }
    const server_response = await ajaxUser.fetchUserProfiles();
    if(server_response.status === "OK"){
      dispatch({type: 'activeProfile', payload: server_response.details.action === 'select' ? false: true});
      if(!server_response.details.data){
        dispatch({type: 'connectedProfiles', payload: '404'});
      }else{
       dispatch({type: 'connectedProfiles', payload: server_response.details.data});
      }
    }else{
      dispatch({type: 'connectedProfiles', payload: '404'});
    }
  }


  const getMyPermissions = async () => {
    if(state.myPermissions){
      return;
    }
    const server_response = await ajaxUser.fetchMyPermissions();
    if(server_response.status === "OK"){
      dispatch({ type: 'myPermissions', payload: server_response.details });
    }else{
      dispatch({ type: 'myPermissions', payload: '404' });
    }
  }


  return(
    <AuthContext.Provider value={{
      ...state, 
      dispatch, 
      getMyProfile,
      getProfiles,
      getMyPermissions
      }}>
      {children}
    </AuthContext.Provider>
  )

}

export const useAuth = ()=>useContext(AuthContext);

